import React from 'react'
import Result from './Result'

const ResultIndex = () => {
    return (
        <Result />
    )
}

export default ResultIndex